/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import { Modern, Element, useFlux, withValue } from 'fierry/react.old';

import Now from 'shared/query/current.time';

import ResourceEnum from 'astro/enum/resource';
import ResourceElement from 'astro/react/element/resource';

import CountdownIcon from 'svg/shared/modern/countdown';


const REFRESH_INTERVAL = 60 * 1000;


const getCurrency = ({ currentUser, now }) =>
{
  return Math.floor(currentUser.getCurrency(now));
}


const getClockCountdown = ({ currentUser, now, galaxy }) =>
{
  const updateDate = galaxy.getCassGalaxy().update_date;

  const multiplier = Math.ceil((now - updateDate) / REFRESH_INTERVAL);

  return Math.floor((updateDate.getTime() + multiplier * REFRESH_INTERVAL - now) / 1000);
}


const getCarbon = ({ currentUser, now }) =>
{
  return Math.floor(currentUser.getResources(now).carbon);
}


const getSilicon = ({ currentUser, now }) =>
{
  return Math.floor(currentUser.getResources(now).silicon);
}


const getHydrogen = ({ currentUser, now }) =>
{
  return Math.floor(currentUser.getResources(now).hydrogen);
}


const Component = ({ className, ...props }) =>
(
  <Modern.Group className = {className} >

    <ResourceElement {...props} type = {ResourceEnum.Currency} value = {getCurrency} />
    <ResourceElement {...props} type = {ResourceEnum.Carbon} value = {getCarbon} />
    <ResourceElement {...props} type = {ResourceEnum.Silicon} value = {getSilicon} />
    <ResourceElement {...props} type = {ResourceEnum.Hydrogen} value = {getHydrogen} />

    <Modern.Param icon = {<CountdownIcon />} text = {getClockCountdown(props)} />

  </Modern.Group>
);


export default (props) =>
{
  const [ now ] = useFlux(Now);

  return <Component {...props} now = {now} />
}
